/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leo_Base_NameInputs */

const en_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const id_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Leo`)
};

const ms_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Leo`)
};

const ca_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA Leo`)
};

const cs_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const da_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const de_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo-KI`)
};

const et_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const es_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo IA`)
};

const fr_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const hr_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const it_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const lv_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo MI`)
};

const lt_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Leo“ dirbtinis intelektas`)
};

const hu_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const nl_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const nb_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const pl_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SI Leo`)
};

const pt_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const ro_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo IA`)
};

const sk_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const sl_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const fi_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo-tekoäly`)
};

const sv_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const vi_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const tr_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo YZ`)
};

const el_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const bg_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const ru_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ-помощник Leo`)
};

const sr_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const uk_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ШІ Leo`)
};

const ka_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const hi_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const th_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const ko_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레오 AI`)
};

const zh_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo 人工智能`)
};

const zh_tw_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

const ja_leo_base_name = /** @type {(inputs: Leo_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI`)
};

/**
* | output |
* | --- |
* | "Leo AI" |
*
* @param {Leo_Base_NameInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const leo_base_name = /** @type {((inputs?: Leo_Base_NameInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leo_Base_NameInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_leo_base_name(inputs)
	if (locale === "ms") return ms_leo_base_name(inputs)
	if (locale === "ca") return ca_leo_base_name(inputs)
	if (locale === "cs") return cs_leo_base_name(inputs)
	if (locale === "da") return da_leo_base_name(inputs)
	if (locale === "de") return de_leo_base_name(inputs)
	if (locale === "et") return et_leo_base_name(inputs)
	if (locale === "es") return es_leo_base_name(inputs)
	if (locale === "fr") return fr_leo_base_name(inputs)
	if (locale === "hr") return hr_leo_base_name(inputs)
	if (locale === "it") return it_leo_base_name(inputs)
	if (locale === "lv") return lv_leo_base_name(inputs)
	if (locale === "lt") return lt_leo_base_name(inputs)
	if (locale === "hu") return hu_leo_base_name(inputs)
	if (locale === "nl") return nl_leo_base_name(inputs)
	if (locale === "nb") return nb_leo_base_name(inputs)
	if (locale === "pl") return pl_leo_base_name(inputs)
	if (locale === "pt") return pt_leo_base_name(inputs)
	if (locale === "ro") return ro_leo_base_name(inputs)
	if (locale === "sk") return sk_leo_base_name(inputs)
	if (locale === "sl") return sl_leo_base_name(inputs)
	if (locale === "fi") return fi_leo_base_name(inputs)
	if (locale === "sv") return sv_leo_base_name(inputs)
	if (locale === "vi") return vi_leo_base_name(inputs)
	if (locale === "tr") return tr_leo_base_name(inputs)
	if (locale === "el") return el_leo_base_name(inputs)
	if (locale === "bg") return bg_leo_base_name(inputs)
	if (locale === "ru") return ru_leo_base_name(inputs)
	if (locale === "sr") return sr_leo_base_name(inputs)
	if (locale === "uk") return uk_leo_base_name(inputs)
	if (locale === "ka") return ka_leo_base_name(inputs)
	if (locale === "hi") return hi_leo_base_name(inputs)
	if (locale === "th") return th_leo_base_name(inputs)
	if (locale === "ko") return ko_leo_base_name(inputs)
	if (locale === "zh") return zh_leo_base_name(inputs)
	if (locale === "zh-tw") return zh_tw_leo_base_name(inputs)
	if (locale === "ja") return ja_leo_base_name(inputs)
	return en_leo_base_name(inputs)
});